<template>

<app-wrapper class="banner" v-bgimage="$state.page.banner">

	<h2>{{ $state.page.title }}</h2>

</app-wrapper>

</template>

<script>

export default {

}

</script>

<style scoped>

.banner {
	background-position: 50% 0%;
	background-size: cover;
	background-color: #eee;
	height: 650px;
	padding-top: 100px;
}

.is-tablet .banner {
	height: 460px;
	padding-top: 64px;
}

.is-mobile .banner {
	height: 360px;
	padding-top: 40px;
}

</style>
